export default ({labels = [], data = [], stepSize = 1000}) => ({
    init() {
        this.$nextTick(() => {
            const id = 'views-last-seven-days';

            const ctx = document.getElementById(id).getContext('2d');

            if (window.Chart.getChart(id)) {
                window.Chart.getChart(id)?.destroy();
            }

            const myChart = new window.Chart(ctx, {
                type: 'line',
                data: {
                    labels,
                    datasets: [{
                        data,
                        borderColor: '#95F11F',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.5,
                        pointRadius: 0,
                    }]
                },
                plugins: [{
                    id: 'backgroundFillOnHover',
                    beforeDraw(chart, args, options) {
                        const {
                            ctx,
                            chartArea: {top, bottom, left},
                            scales: {x, y}
                        } = chart;

                        const activeElement = chart.getActiveElements()[0];

                        if (!activeElement) {
                            return;
                        }
                        const index = activeElement.index;
                        const dataset = chart.data.datasets[0];

                        const gradientBackground = ctx.createLinearGradient(0, bottom, 0, top);
                        gradientBackground.addColorStop(0, 'rgba(228, 251, 197, 0.05)');
                        gradientBackground.addColorStop(1, '#fff');

                        ctx.save();
                        ctx.fillStyle = gradientBackground;

                        ctx.beginPath();
                        ctx.moveTo(left, bottom);

                        for (let i = 0; i <= index; i++) {
                            const currentX = x.getPixelForValue(i);
                            const currentY = y.getPixelForValue(dataset.data[i]);

                            if (i === 0) {
                                ctx.lineTo(currentX, currentY);
                            } else {
                                const previousX = x.getPixelForValue(i - 1);
                                const previousY = y.getPixelForValue(dataset.data[i - 1]);

                                const controlPointPreviousX = previousX + (currentX - previousX) / 2 * dataset.tension;
                                const controlPointCurrentX = currentX - (currentX - previousX) / 2 * dataset.tension;

                                ctx.bezierCurveTo(
                                    controlPointPreviousX, previousY,
                                    controlPointCurrentX, currentY,
                                    currentX, currentY
                                );
                            }
                        }

                        const lastX = x.getPixelForValue(index);

                        ctx.lineTo(lastX, bottom);
                        ctx.lineTo(left, bottom);

                        ctx.closePath();
                        ctx.fill();

                        ctx.restore();
                    }
                },
                    {
                        id: 'addInnerCircleOnPointRadius',
                        beforeTooltipDraw(chart, args, options) {
                            const ctx = chart.ctx;
                            const activeElement = chart.getActiveElements()[0];

                            if (activeElement) {
                                const {index, datasetIndex} = activeElement;
                                const meta = chart.getDatasetMeta(datasetIndex);
                                const point = meta.data[index];
                                const {x, y} = point.tooltipPosition();
                                const yAxisBottom = chart.scales.y.bottom;
                                const value = chart.data.datasets[datasetIndex].data[index];

                                //  External Ellipse
                                ctx.save();
                                ctx.beginPath();
                                ctx.ellipse(x, y, 17.38 / 2, 16.24 / 2, 0, 0, 2 * Math.PI);
                                ctx.fillStyle = '#fff';
                                ctx.strokeStyle = '#540889';
                                ctx.lineWidth = 2;
                                ctx.fill();
                                ctx.stroke();
                                ctx.restore();

                                // Internal Ellipse
                                ctx.save();
                                ctx.beginPath();
                                ctx.ellipse(x, y, 7.73 / 2, 7.22 / 2, 0, 0, 2 * Math.PI);
                                ctx.fillStyle = '#540889';
                                ctx.fill();
                                ctx.restore();

                                if (value > 0) {
                                    // Line from the ellipsis to the label
                                    ctx.save();
                                    ctx.beginPath();
                                    ctx.moveTo(x, y + 17.38 / 2);
                                    ctx.lineTo(x, yAxisBottom);
                                    ctx.strokeStyle = '#B55BF5';
                                    ctx.lineWidth = 1;
                                    ctx.stroke();
                                    ctx.restore();
                                }
                            }
                        }
                    },
                ],
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                options: {
                    onHover: (event, activeElements, chart) => {
                        const activeElement = activeElements[0];
                        const dataset = chart.data.datasets[0].data;

                        if (!activeElement) {
                            return;
                        }

                        const colors = new Array(dataset.length).fill('#666');
                        colors[activeElement.index] = '#540889';

                        chart.config.options.scales.x.ticks.color = colors;

                        chart.update();
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        backgroundFillOnHover: {},
                        highlightLabel: {},
                        tooltips: {
                            position: 'nearest'
                        }
                    },
                    clip: false,
                    scales: {
                        x: {
                            grid: {
                                display: false,
                            },
                            border: {
                                display: false
                            },
                        },
                        y: {
                            border: {
                                display: false,
                            },
                            beginAtZero: true,
                            ticks: {
                                stepSize,
                                callback(value) {
                                    return value >= 1000 ? `${value / 1000}K` : value;
                                }
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'index',
                        intersect: false,
                    },
                }
            });

            myChart.canvas.addEventListener('mouseout', () => {
                const labelsLength = myChart.data.labels.length;

                myChart.config.options.scales.x.ticks.color = new Array(labelsLength).fill('#666');

                myChart.update();
            });
        });
    }
})
